import Chip from "@mui/material/Chip";

import ChapterModel from "src/models/ChapterModel";

const ChapterWeight = ({ chapter }: { chapter: ChapterModel }) => {
  return <Chip label={`${chapter.weight} weight`} variant="outlined" color="default" size="small" sx={{ mt: 0.5 }} />;
};

export default ChapterWeight;
